import { useQuery } from '@tanstack/react-query';
import { ApiError, api } from '@/lib/api';

export function useMeta() {
	return useQuery({
		queryKey: ['meta'],
		staleTime: Infinity,
		queryFn: async () => {
			const { data, response } = await api.GET('/api/v1/meta');
			if (!data) throw new ApiError(response.status, '/api/v1/meta');
			return data;
		},
	});
}
